import { Injectable } from '@angular/core';
import { PosHttpService } from '../services/pos.http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  constructor(
    private posHttpSvcs:PosHttpService,
  ) { }

  getMenuJson():Observable<any>{
    return this.posHttpSvcs.authGet('v1/auth/menues','menues'); 
  }


}
